import React from "react";
import journeys from "../static/data/journeys.js";
import amritsar from "../static/images/amritsar.jpg";
import kerala from "../static/images/kerela.jpg";
import kashmir from "../static/images/kashmir.jpg";
import ladakh from "../static/images/ladakh.jpg";
import bentota from "../static/images/product/bentota/bentota_main.png";
import nuwara from "../static/images/product/nuwara/nuwara_main.png";
import kandy from "../static/images/product/kandy/kandy_main.png";
import bhutan from "../static/images/product/bhutan/bhutan_it_2.png";
import triangle from "../static/images/product/triangle/triangle_main.jpg";
import "../sass/main.scss";
import { NewJourneyCard } from "./journeyCard.js";
import { useNavigate } from "react-router-dom";
import useWindowDimensions from "../hooks/useWindowDimensions.js";

const IMAGES = {
  kerala,
  kashmir,
  amritsar,
  ladakh,
  bentota,
  nuwara,
  kandy,
  triangle,
  bhutan
};

export const SignatureJourneys = ({ currentJourney }) => {
  const navigate = useNavigate();
  const [highlightedIndex, setHighlightedIndex] = React.useState(null);
  const { width } = useWindowDimensions();

  const renderCards = React.useMemo(() => {

    return journeys
      .map(destination => {
        const country = destination.country;
        return destination
          .tours
          .filter(dest => dest.destination !== currentJourney)
          .map((dest, ind) => {
            const shouldHighlight = highlightedIndex === ind;
            return (
              <NewJourneyCard
                navToFunction={() => {
                  navigate("/book", {
                    state: {
                      country: country,
                      destination: dest.destination,
                    },
                  });
                }}
                shouldRenderEnquireButton={dest.attractions !== "Coming Soon"}
                navTo={currentJourney ? `/:${country}/:${dest.destination}` : `:${country}/:${dest.destination}`}
                key={ind}
                img={IMAGES[dest.img_filename]}
                dest={dest}
                shouldHighlight={shouldHighlight}
                index={ind}
                currentCountry={country}
                setHighlightedIndex={setHighlightedIndex}
              />
            );
          });
      });
  }, [currentJourney, highlightedIndex, navigate]);

  return (
    <div className="outer-container" style={{ marginTop: (!currentJourney && width > 600) && "4rem" }}>
      {!currentJourney && <h1>Signature Journeys</h1>}
      <div className="signature-journeys-container">
        <div className="sj-card-container" id="scrollbar-style">
          {renderCards}
        </div>
        <div className="scrollbar-container">
        </div>
      </div>
    </div>
  );
};
